import store from '@/store';
import LoggedInFrontpage from '@/views/LoggedInFrontpage';
import NoLoginFrontpage from '@/views/NoLoginFrontpage';

export default {
  functional: true,
  render(h) {
    if (store.getters['user/isAuthenticated']) {
      return h(LoggedInFrontpage);
    } else {
      return h(NoLoginFrontpage);
    }
  },
};
